<template>
  <v-dialog
    content-class="recovery-codes-generator-dialog"
    v-model="dialog"
    persistent
    max-width="440">
    <div>
      <v-icon class="rcg-close" @click.stop="closeDialog()">close</v-icon>
      <h1 class="rcg-heading">{{ $t('Account.Recovery.Header') }}</h1>
      <div class="rcg-content">
        <span v-html="$t('Account.Recovery.Text')"></span>
      </div>
      <button class="v-btn primary-btn" @click="generateCodes()">
        <span >{{ $t('Account.Recovery.Button') }}</span>
      </button>
    </div>
  </v-dialog>
</template>

<script>
// import config from '@/config'
import store from '@/store'
import Branding from '@/components/mixins/Branding'
import Screen from '@/components/mixins/Screen'
import lib from '@/library'

export default {
  data () {
    return {
      dialog: true,
      dialogMini: false
    }
  },
  mixins: [
    Screen,
    Branding
  ],

  computed: {
    isLoggedIn () {
      return store.getters['isLoggedIn']
    },
    showRecoveryCodesGeneratorDialog () {
      return store.getters['getShowRecoveryCodesGeneratorDialog']
    }
  },

  methods: {
    closeDialog () {
      this.dialog = false
    },
    generateCodes () {
      lib.rpcService.callBroker('iw', 'codesGenerate', {})
      this.closeDialog()
    }
  },
  watch: {
    isLoggedIn (newVal) {
      if (newVal) {
        this.closeDialog()
      }
    },
    showRecoveryCodesGeneratorDialog (newVal) {
      if (newVal) this.dialog = true
    }
  }
}
</script>

<style lang="stylus">
@import '~@/css/config'

.recovery-codes-generator-dialog
  > div
    position relative
    i 
      position absolute
      right -5px
      top -5px
      color var(--auth-recovery-icon-close) !important
  h1
    margin-bottom 10px
    line-height 24px
    color var(--auth-recovery-heading) !important
    @media mobile-big-and-below
      max-width 95%
  button 
    margin 0
    margin-top 10px
    text-transform none
    background: var(--auth-recovery-button) !important
    color var(--auth-recovery-button-text) !important
  .rcg-content
    color var(--auth-recovery-rcg-content) !important
    font-size 14px
  .note
    display block
    font-size 12px
    color  var(--auth-recovery-note) !important
    margin-top 10px

</style>



// WEBPACK FOOTER //
// src/components/account/IntegratedWallet/RecoveryCodesGeneratorDialog.vue